import React from 'react'
import moment from 'moment'
import { SingleDatePicker } from 'react-dates';


import Button from '../common/button';
import TextField from '../common/textField';
import RadioButton from '../common/radioButton';
import AutoComplete from '../citySearchAutoComplete';

import './styles.css';

const actionButtonStyle = { width: '90%', height: 50, padding: 0, margin: '10px 5px 30px 0px' }
const searchButtonStyle = { width: '70%', height: 42, padding: 0, margin: '10px 5px 30px 20px' }

const CancellationOfferInputFields = (props) => {
  return(
    <div className="col-xs-9 payout-content">
      <p className='colorb3b3b3 marginBtm20'>Note: * marked fields are mandatory.</p>
      <div className="row">
        <div className="col-xs-3 deal-padding-right deal-textfield">
          <AutoComplete
            fieldName="source"
            placeholder="Source *"
            isDisabled={props.isEditCase}
            defaultValue={props.source}
            onSelect={props.onSourceItemSelect}
          />
        </div>
        <div className="col-xs-3 deal-textfield deal-padding-right">
          <AutoComplete
            fieldName="destination"
            placeholder="Destination *"
            isDisabled={props.isEditCase}
            defaultValue={props.destination}
            onSelect={props.onDestinationItemSelect}
          />
        </div>
        { !props.isEditCase &&
          <div className="col-xs-3 service-search-button">
            <Button styleObj={searchButtonStyle} label="Search" onButtonClick={props.onSearchClick} />
          </div>
        }
      </div>

      {/*props.routeServices.length > 0 &&*/
        <div className="marginTop25">
          <p className="color182233 marginBtm20"><b>Select Service(s) to add</b></p>
          <RadioButton
            label="All Services"
            isChecked={props.isAllServicesSelected}
            onSelectionChange={props.onServiceOptionChange} />
          <RadioButton
            label="Selected Service"
            isChecked={!props.isAllServicesSelected}
            onSelectionChange={props.onServiceOptionChange} />
        </div>
      }

      {
        !props.isAllServicesSelected && props.routeServices.length?
          <div className="row deal-services-wrp marginTop10">
            {
              props.routeServices.map((el, index) => (
                <div key={index} className="deals-services">
                  <RadioButton
                    label={`${moment(el.departure_datetime).format('hh:mm a')}, ${el.bus_type_name}`}
                    isChecked={props.selectedServices.includes(el.route_time_id)}
                    onSelectionChange={(label, isChecked) =>
                      props.onSearvicesSelection(el.route_time_id, isChecked, props.dealType,el)
                    }
                  />
                </div>
              ))
            }
          </div>
        : null
      }

      <div className="col-xs-12 marginTop25">
        <p className="color182233"><b>Cancellation Policy</b></p>
        <p className="color222 marginTop8">Free cancellation available below hours before departure:</p>
        <div className="col-xs-4">
          <TextField
            type="number"
            name="hoursBeforeDep"
            value={props.hoursBeforeDep}
            onChange={props.onInputFieldChange}
            placeholder="Hours Before Departure"
            errorMsg={''}
          />
        </div>
      </div>
     
     <div className="col-xs-12 validity-wrp">
      <p className="color182233"><b>Validity</b></p>
      <p className="color222 marginTop8 marginBtm20">Offer valid for bookings done till:</p>
      <div className="col-xs-4 datepicker-wrp">
        <SingleDatePicker
          id="start_date"
          // disabled={props.isEditCase}
          daySize={30}
          date={props.endDate}
          placeholder="Select Date *"
          displayFormat="DD-MM-YYYY"
          focused={props.focusedEndDate}
          hideKeyboardShortcutsPanel={true}
          onDateChange={props.onEndDateChange}
          onFocusChange={props.onEndFocusChange}
          isOutsideRange={props.EndDateRangeChecker}
        />
      </div>
     </div>

      <div className="row" style={{ flexDirection: 'row-reverse' }}>
        <div className="col-xs-3">
          <Button
            styleObj={actionButtonStyle}
            label={props.isEditCase? "Update": "Create"}
            onButtonClick={props.onCreateOfferClick}
          />
        </div>
        <div className="col-xs-3">
          <Button
            styleObj={actionButtonStyle}
            label="Cancel"
            onButtonClick={props.onCancelClick}
          />
        </div>
      </div>
    </div>
  )
}

export default CancellationOfferInputFields;
